var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRefererProvider(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.785 10.938a5.469 5.469 0 1 1 0-10.938 5.469 5.469 0 0 1 0 10.938Zm0-8.75a3.281 3.281 0 1 0 0 6.562 3.281 3.281 0 0 0 0-6.563ZM20.785 28a5.469 5.469 0 1 1 0-10.937 5.469 5.469 0 0 1 0 10.937Zm0-8.75a3.28 3.28 0 1 0 0 6.562 3.28 3.28 0 0 0 0-6.562ZM13.732 17.46l-3.064-1.751a5.47 5.47 0 0 0 0-3.418l3.064-1.75a1.094 1.094 0 0 0-1.085-1.9L9.58 10.393a5.469 5.469 0 1 0 0 7.214l3.067 1.752a1.093 1.093 0 1 0 1.085-1.899Zm-8.26-.179a3.281 3.281 0 1 1 0-6.562c4.343 0 4.338 6.562 0 6.562Z",
    fill: "#2FAEF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.473 15.094a1.094 1.094 0 1 0 0-2.188 1.094 1.094 0 0 0 0 2.188Z",
    fill: "#2FAEF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefererProvider);
export default __webpack_public_path__ + "static/media/icon_referer_provider.8447f9efcaad7a539a6e91830174379f.svg";
export { ForwardRef as ReactComponent };